import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-lookup-child-account-modal',
  templateUrl: './lookup-child-account-modal.component.html',
  styleUrls: ['./lookup-child-account-modal.component.scss']
})
export class LookupChildAccountModalComponent implements OnInit, OnDestroy {

  @ViewChild("lookupChildAccountModal", { static: false }) EftModal: TemplateRef<any>;

  public closeResult: string;
  public modalOpen: boolean = false;
  modal: NgbModalRef;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  async openModal() {
    this.modalOpen = true;
    this.modal = this.modalService.open(this.EftModal, {
      ariaLabelledBy: 'eft-modal',
      centered: true,
      size: 'md',
      windowClass: 'Top'
    });

    this.modal.result.then((result) => {
      `Result ${result}`
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

}
